//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalIcon, { generalRightArrow, topNavNext } from '@tidal/styles-icons';

export default {
    components: {
        tidalIcon,
    },
    props: {
        link: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        target: {
            type: String,
            default: null,
        },
        external: {
            type: Boolean,
            default: false,
        },
        externalArrow: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            icons: {
                generalRightArrow,
                topNavNext,
            },
        };
    },
};
